var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"asset_type","title":"Asset Type","access":"master_asset_type","pk":"matyId","columns":_vm.columns,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }